export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.directive('click-outside', {
      mounted: (element, binding) => {
        element.clickOutsideEvent = function (event: { target: Node | null }) {
          const excludeComponent = binding.arg ? document.getElementById(binding.arg) : null

          if (
            !(element == event.target || element.contains(event.target))
            && !(excludeComponent && (event.target == excludeComponent || excludeComponent.contains(event.target)))
          ) {
            binding.value(event, element)
          }
        }
        document.addEventListener('click', element.clickOutsideEvent)
      },
      unmounted: (element) => {
        document.removeEventListener('click', element.clickOutsideEvent)
      },
    })
  },
})
